import { Spacing } from './types';

export const unit = 5;

const spacing: Spacing = {
  xxxs: `${unit}px`,
  xxs: `${unit * 2}px`,
  xs: `${unit * 4}px`,
  s: `${unit * 8}px`,
  m: `${unit * 16}px`,
  l: `${unit * 24}px`,
  xl: `${unit * 32}px`,
  xxl: `${unit * 44}px`,
  units: units => `${unit * units}px`,
};

export default spacing;
